import React from 'react';
import { useAppDispatch } from '@/store/hooks';
import { setPageSize, setCurrentPage } from '@/store/slices/filesSlice';

interface PageSizeSelectProps {
  currentPageSize: number;
}

export const PageSizeSelect: React.FC<PageSizeSelectProps> = ({
  currentPageSize,
}) => {
  const dispatch = useAppDispatch();

  const handlePageSizeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newPageSize = parseInt(event.target.value, 10);
    dispatch(setPageSize(newPageSize));
    dispatch(setCurrentPage(0));
  };

  return (
    <div className="flex items-center space-x-2">
      <label
        htmlFor="pageSize"
        className="text-sm text-gray-500 dark:text-gray-400"
      >
        Afficher
      </label>
      <select
        id="pageSize"
        value={currentPageSize}
        onChange={handlePageSizeChange}
        className="h-8 rounded-md border border-gray-300 bg-white py-1 pl-2 pr-6 text-sm text-gray-700 shadow-sm transition-all duration-300 hover:border-gray-400 focus:border-primary focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-gray-500"
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
      <span className="text-sm text-gray-500 dark:text-gray-400">éléments</span>
    </div>
  );
};
